import type { StyleRule } from '@archipro-design/aria';

export const DevicePreviewOverlay: StyleRule = () => ({
    pointerEvents: 'none',
    [`& a`]: {
        pointerEvents: 'none',
    },
});
